export default __webpack_public_path__ + "static/neue-haas-grotesk-text-65-medium-fb6bf5a89b588b40e679017c3625ae0c.woff2";